@if (urlTarget) {
  <a [href]="link" [target]="urlTarget">{{ value }}</a>
} @else {
  <a [href]="link">{{ value }}</a>
}
